<template>
  <div class="form-row">
    <div class="form-group col-12">
      <p class="font-weight-bold">Select light</p>
      <div class="models-wrapper">
        <div class="mr-3">
          <div>
              <button
                @click="selectLight('point')"
                class="btn btn-primary"
              >
                Point light
              </button>
            </div>
        </div>
        <div class="mr-3">
          <div>
              <button
                @click="selectLight('spot')"
                class="btn btn-primary"
              >
                Spot light
              </button>
            </div>
        </div>
        <div class="mr-3">
          <div>
              <button
                @click="selectLight('directional')"
                class="btn btn-primary"
              >
                Directional light
              </button>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import { mapState } from 'vuex'
import { uuid } from 'vue-uuid'

export default {
  components: {},
  data () {
    return {
      allCharacters: []
    }
  },
  methods: {
    selectLight (type) {
        let id = uuid.v1()
        this.allCharacters = this.characters.map((char) => ({ ...char, active: false }))
        let selectedOne = {
            objectId: id,
            type: "Light",
            lightType: type,
            range: 1,
            startTime: 0,
            endTime: 10,
            indirectMultiplier: 0,
            lightMode: 'Realtime',
            lightMaps: '',
            shadowType: 'None',
            shadowStrength: 1,
            color: "#ffffff",
            exposure: 1,
            duration: 5,
            localPosition: [
                0,
                0,
                0
            ],
            localRotation: [
                0,
                0,
                0
            ],
            active: true,
      }
      if(type == 'spot') {
          selectedOne.innerSpotAngle = 0 
          selectedOne.outerSpotAngle = 0 
      }
      this.$store.dispatch('updateCharacters', [
        ...this.allCharacters,
        selectedOne
      ])
      this.$emit('closePopup')
    }
  },
  mounted () {},
  watch: {},
  computed: {
    ...mapState([
      'characters'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/v2/story-edit-view/timeline-components/light.vue